<template>
  <div>
    <!-- <v-data-table
      v-model="selected"
      :headers="headers"
      :items="desserts"
      :single-select="singleSelect"
      item-key="name"
      show-select
      class="elevation-1"
    >
      <template v-slot:top>
        <v-switch
          v-model="singleSelect"
          label="Single select"
          class="pa-3"
        ></v-switch>
      </template>
    </v-data-table> -->
    <v-card class="elevation-0">
      <v-container class="pt-0">
        <v-card-title class="mt-0">
          <v-text-field v-model="search" label="Search" clearable="clearable">
          </v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" v-model="selected" :items="locations" item-key="CSPID" :loading="loading"
          :search="search" :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-left small-td pointer">
                <v-checkbox v-model="item.selected" hide-details :label="item.CSPID">
                  <v-icon small v-if="item.isLocked">lock</v-icon>
                </v-checkbox>
              </td>
              <td class="text-left small-td pointer">
                {{ item.businessName
                }}<v-icon class="ml-1" small v-if="item.isCanceled" color="red">desktop_access_disabled
                </v-icon>
              </td>
              <td class="text-left small-td pointer">
                {{ item.address }}
              </td>
              <td class="text-xs center">
                <toggle-button v-model="item.onlyTransfer" :value="item.onlyTransfer" :sync="true">
                </toggle-button>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>
        </v-data-table>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import locationService from "../service.js";
import { mapGetters } from "vuex";

export default {
  name: "location-list",
  data() {
    return {
      selected: [],
      sortBy: "createdAt",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      terminalURL: process.env.VUE_APP_TERMINALURL,
      headers: [
        {
          text: this.$t("labels.cspID"),
          align: "left",
          sortable: true,
          value: "CSPID",
        },
        {
          text: this.$t("labels.name"),
          value: "businessName",
          sortable: true,
        },
        {
          text: this.$t("labels.address"),
          value: "address",
          sortable: true,
        },
        {
          text: this.$t("labels.showInTransferOnly"),
          value: "showInTransferOnly",
          sortable: false,
        },
      ],
      search: null,
      locations: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "businessName",
      },
    };
  },
  async created() {
    await this.getList();
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"]),
    ...mapGetters("group", ["selectedLocation"]),
  },
  watch: {
    // selectedLocation(val) {
    //   val.forEach((row) => {
    //     console.log("selectedLocation", val, this.locations);
    //     this.locations.forEach((location) => {
    //       console.log("row", row);
    //       if (location.storeID === row.storeID) {
    //         console.log("transfer status", row.onlyTransfer);
    //         location.selected = true;
    //         location.onlyTransfer = row.onlyTransfer;
    //       }
    //     });
    //   });
    // },
    locations: {
      handler(val) {
        let selectedLocation = [];
        val.forEach((row) => {
          if (row.selected) {
            selectedLocation.push(row);
          }
        });
        this.$emit("selectedLocations", selectedLocation);
      },
      deep: true,
    },
  },
  methods: {
    getList() {
      return locationService
        .getAllLocation(this.currentOrganization.organizationID, {})
        .then((response) => {
          console.log("response location", response);
          console.log("response selectedLocations", this.selectedLocation);
          this.locations = response.data;
          if (this.selectedLocation) {
            this.setSelection()
          }
          this.loading = false;
          return response;
        });
    },
    setSelection() {
      this.selectedLocation.forEach((row) => {
        this.locations.forEach((location) => {
          if (location.storeID === row.storeID) {
            console.log("transfer status", row.onlyTransfer);
            location.selected = true;
            location.onlyTransfer = row.onlyTransfer;
          }
        });
      });
    },
    viewLocation(location) {
      this.$router.push({ path: `/location/${location.storeID}/profile` });
    },
  },
};
</script>
